import { Box, SxProps } from '@mui/system';
import Loader from './Loader';
import FlexBox from './FlexBox';
import { useFullScreenLoader } from '@/hooks/useFullScreenLoader';

type FullScreenLoaderProps = {
	isVisible: boolean;
};

function FullScreenLoader() {
	const { isVisible } = useFullScreenLoader();

	if (!isVisible) return null;

	return (
		<FlexBox
			fullWidth
			id='full-screen-loader'
			sx={{
				position: 'fixed',
				left: 0,
				top: 0,
				height: '100%',
				width: '100vw',
				zIndex: 10000,
				background: 'rgba(0, 0, 0, .4)',
				overflowY: 'hidden',
			}}
		>
			<Loader />
		</FlexBox>
	);
}

export default FullScreenLoader;
